import React, { createContext, useContext, useState } from 'react';
import PropTypes from "prop-types"

export const NavbarContext = createContext();

const initState = {
  navInd:0,
  subNavInd:0,
  showSubNav:false,
  subNavData:[]
}

export const NavbarProvider = ({ children }) => {

  const [navbarState, setNavbarState] = useState(initState);

  return (
    <NavbarContext.Provider value={{ navbarState, setNavbarState }}>
      {children}
    </NavbarContext.Provider>
  );
};

NavbarProvider.propTypes = ({
  children : PropTypes.node
})

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within a NavbarProvider');
  }
  return context;
};
